import { Injectable } from '@angular/core';

export interface ClientHistoryState {
  loaded: boolean;
  religion: string | null;
  items: any[];
  filters: any;
  pagination: any;
  page: number;
  selectedIntentType: string;
  selectedFocus: string;
  selectedTopic: string;
  selectedRating: string;
  selectedTags: string[];
  search: string;
  showAllReligions: boolean;
}

const DEFAULT_STATE: ClientHistoryState = {
  loaded: false,
  religion: null,
  items: [],
  filters: { intent_types: [], focuses: [], topics: [] },
  pagination: {},
  page: 1,
  selectedIntentType: '',
  selectedFocus: '',
  selectedTopic: '',
  selectedRating: '',
  selectedTags: [],
  search: '',
  showAllReligions: false,
};

@Injectable({ providedIn: 'root' })
export class ClientHistoryStateService {
  private state: ClientHistoryState = { ...DEFAULT_STATE };

  snapshot(): ClientHistoryState {
    return {
      ...this.state,
      items: [...this.state.items],
      selectedTags: [...this.state.selectedTags],
      filters: { ...this.state.filters },
      pagination: { ...this.state.pagination },
    };
  }

  hydrate(partial: Partial<ClientHistoryState>): void {
    this.state = { ...this.state, ...partial };
  }

  reset(): void {
    this.state = { ...DEFAULT_STATE };
  }

  isStale(currentReligion: string | null): boolean {
    if (!this.state.loaded) return true;
    return this.state.religion !== currentReligion;
  }
}
